import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import { ContentBox, ContentBoxHead, ContentBoxBody } from '../Components/ContentBox';
import { LoginEmail, LoginForm, LoginPassword, LoginSubmit } from '../Components/Login/login_form';
/**********************************************************************
 * Component:  LoginPageTemplate
 * Purpose:    Handles Login and redirects user to various places
 *             based on the player action table.
 *
 * Props:       user -  user data store
 *              actions - store actions (apis)
 *              children -  any child components to be rendered
 *
 * APIs used:   None
 *
 *  Notes:
 */
const LoginPage = ({ user, config, cmsSourceFirebase, actions }) => {
    const page = {
        title: 'Login in',
        className: 'login-template',
    };

    if (user.loggedIn) {
        // Check if there is a redirection parameter and redirect accordingly if there are no
        // actions to do in the Actions table.
        const redirect = new URLSearchParams(document.location.search).get('redirect');
        const partner = new URLSearchParams(document.location.search).get('partner');
        if (user.loggedIn && user.player?.actions?.length === 0 && partner === 'store' && redirect && config.config.store_uri) {
            window.location.href = config.config.store_uri + '/' + redirect;
            return null;
        } else {
            return <Redirect to={redirect || (config?.site?.successfulLoginRedirect ?? '/enter')} />;
        }
    }

    const totalLoginAttempts = config?.site?.totalLoginAttempts;
    const userAttemps = user?.errorData?.attempts ?? 0;
    const attemptsLeft = totalLoginAttempts - userAttemps;

    const replace = {
        ATTEMPT_NUMBER_LEFT: attemptsLeft,
        ATTEMPT_PLURAL: attemptsLeft === 1 ? 'attempt' : 'attempts',
    };

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match: page }}>
            <div className='login-container'>
                <LoginForm>
                    <ContentBox variant='theme-blue'>
                        <ContentBoxHead>Login </ContentBoxHead>
                        <ContentBoxBody>
                            <LoginEmail replace={replace} />
                            <LoginPassword replace={replace} />
                        </ContentBoxBody>
                    </ContentBox>
                    <div className='bottom-section'>
                        <LoginSubmit />
                    </div>
                </LoginForm>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
